module.exports = __webpack_public_path__ + "img/sqhk.28088138.png";